// frontend/src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import authService from './services/authService'; // Importar el servicio de autenticación
import './styles/global.css';


// Inicializar el servicio de autenticación
authService.initAuth();

// Manejador global de errores no capturados
window.addEventListener('unhandledrejection', async (event) => {
  console.error('Unhandled Promise Rejection:', event.reason);
  
  // Si el error está relacionado con Firestore, intentar reconectar
  if (event.reason && (
    event.reason.message?.includes('firestore') || 
    event.reason.message?.includes('webchannel')
  )) {
    console.log('Detectado error de Firestore, intentando reconectar...');
    try {
      await authService.handleFirestoreError();
    } catch (error) {
      console.error('Error al manejar error de Firestore:', error);
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();